function parseEmailList(raw: string): Set<string> {
  return new Set(
    raw
      .split(",")
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean),
  );
}

/**
 * Admin allowlist: `ADMIN_EMAILS` in Node (Express). In the browser build, use the same list in
 * `VITE_ADMIN_EMAILS` (comma-separated) so the UI can show admin nav; real protection still needs RLS / server checks.
 */
export function adminEmailAllowlist(): Set<string> {
  if (typeof process !== "undefined" && typeof process.env?.ADMIN_EMAILS === "string" && process.env.ADMIN_EMAILS.trim()) {
    return parseEmailList(process.env.ADMIN_EMAILS);
  }
  const vite = typeof import.meta !== "undefined" ? import.meta.env?.VITE_ADMIN_EMAILS : undefined;
  if (typeof vite === "string" && vite.trim()) {
    return parseEmailList(vite);
  }
  return new Set();
}

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email?.trim()) return false;
  const allow = adminEmailAllowlist();
  if (allow.size === 0) return false;
  return allow.has(email.trim().toLowerCase());
}
